<script >
import { ref, reactive, defineAsyncComponent, onBeforeMount, set } from 'vue-demi';
import '@futuweb/quote-charts/lib/SparkChart/style/index.css';
const SparkChart = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/SparkChart'));
import { getSchemeLink, PROTOCOL_TYPE } from '../assets/config/scheme';
import { IncreaseType, IncreaseTypeMap } from '../assets/config/index';
import { SUBSCRIBED, UNSUBSCRIBED } from '../assets/config/lang';
import useCustomRank from './useCustomRank';
import useMarketValRank from './useMarketValRank';
import useMarketRank from './useMarketRank';
import useChart from './useChart';
import useComputedProps from './useComputedProps';
const __sfc_main = {};
__sfc_main.props = {
  market_id: Number || String,
  sort_id: Number,
  language: Number,
  upDownColor: Number,
  title: String,
  subTitle: String,
  topImg: String,
  count: Number,
  customStocklist: Array,
  schemeType: String,
  schemeProtocol: {
    type: String,
    default: PROTOCOL_TYPE.NN
  },
  // 涨幅类型
  increaseType: String,
  tagString: String,
  col_name: String,
  col_trend: String,
  col_subscribe: String,
  show_subscribe_number: Boolean
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useLang,
    usePageType,
    useCommonApi,
    useBehaviour
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const {
    runBehaviour
  } = useBehaviour();
  const request = useCommonApi('quote-rank');
  const wchApi = useCommonApi('self-selected-stocks');
  const {
    useToast
  } = require('@fegobull/webapi').use;
  const Toast = useToast();
  const props = __props;
  const {
    lang
  } = useLang();
  const stockList = ref([]);
  const chartDatas = reactive({});
  const stockStatus = reactive({});
  const stockWchNum = reactive({});

  /* 自定义排行 */
  const {
    isCustomRank,
    getCustomRank
  } = useCustomRank(props, request);
  /* 市值排行 */
  const {
    isMarketValRank,
    isHotDividendsRanking,
    getMarketValRank,
    getHotDividendsRanking
  } = useMarketValRank(props, request);
  /* 市场热度排行 */
  const {
    getMarketRank
  } = useMarketRank(props, request);

  /* 图表分时数据 & K线数据 */
  const {
    getChartData,
    getKlineData
  } = useChart(props, request);

  /* 部分 props 的消费需要进过一定的逻辑处理 */
  const {
    tagMap,
    isSupported
  } = useComputedProps(props);
  const jumpLogin = () => {
    runBehaviour(null, {
      type: 'login',
      value: location.href,
      withQuery: true
    });
  };

  /* 自选股票状态 */
  const getStatus = async stock => {
    const params = {
      stockId: stock.stockId
    };
    try {
      const r = await wchApi.get('status', params);
      return r;
    } catch (err) {
      console.log('stocks status err', err);
    }
  };
  /* 自选股票订阅人数 */
  const getNum = async stock => {
    const params = {
      stockId: stock.stockId
    };
    try {
      const r = await wchApi.get('wchNum', params);
      return r;
    } catch (err) {
      console.log('stock wchnum err', err);
    }
  };
  // 订阅自选股
  const subscribeStock = async stock => {
    const params = {
      stockId: stock.stockId
    };
    try {
      const r = await wchApi.post('subscribeStock', params);
      if (r.code === 10002) {
        return jumpLogin();
      }
      set(stockStatus, stock.stockId, true);
      if (props.show_subscribe_number) {
        set(stockWchNum, stock.stockId, stockWchNum[stock.stockId] + 1);
      }
      Toast.msg(SUBSCRIBED[lang]);
    } catch (e) {
      console.log(e);
    }
  };
  // 解除订阅自选股
  const unSubscribeStock = async stock => {
    const params = {
      stockId: stock.stockId
    };
    try {
      const r = await wchApi.post('cancelSubscribeStock', params);
      if (r.code === 10002) {
        return jumpLogin();
      }
      set(stockStatus, stock.stockId, false);
      if (props.show_subscribe_number) {
        set(stockWchNum, stock.stockId, stockWchNum[stock.stockId] - 1);
      }
      Toast.msg(UNSUBSCRIBED[lang]);
    } catch (e) {
      console.log(e);
    }
  };

  /* 初始化股票订阅数据 */
  const initStockData = async () => {
    if (!stockList.value || !stockList.value.length) {
      return;
    }

    // 并行请求股票数据
    await Promise.all(stockList.value.map(async stock => {
      // const res_status = await getStatus(stock);
      // set(stockStatus, stock.stockId, res_status?.data?.result || false);

      // if (props.show_subscribe_number) {
      //     const res_num = await getNum(stock);
      //     set(stockWchNum, stock.stockId, res_num?.data?.result || 0);
      // }
      const res_status = await getStatus(stock);
      const res_num = await getNum(stock);
      set(stockStatus, stock.stockId, res_status?.data?.result || false);
      set(stockWchNum, stock.stockId, res_num?.data?.result || 0);
    }));
  };
  /* 初始化股票图表数据 */
  const initChartData = async () => {
    if (!stockList.value || !stockList.value.length) {
      return;
    }
    // 并行请求图表数据
    await Promise.all(stockList.value.map(async stock => {
      const {
        increaseType
      } = props;
      if (increaseType === IncreaseType.DAY_INCREASE) {
        // 今日升幅 - 请求分时图
        const chartData = (await getChartData(stock)) || [];
        set(chartDatas, stock.stockId, chartData);
      } else {
        // 其他升幅 - 请求K线图
        const klineData = (await getKlineData(stock)) || [];
        set(chartDatas, stock.stockId, klineData);
      }
    }));
  };
  /* 跳转详情页 */
  const goScheme = stock => {
    if (props.schemeType) {
      const link = getSchemeLink(props.schemeType, stock, props.schemeProtocol || PROTOCOL_TYPE.MOOMOO);
      link && runBehaviour(null, {
        type: props.schemeProtocol === PROTOCOL_TYPE.NN ? 'jump' : 'jumpMM',
        value: link
      });
    }
  };
  const subscribeHandler = async stock => {
    const hasSubscribe = stockStatus[stock.stockId];
    if (hasSubscribe) {
      try {
        return await unSubscribeStock(stock);
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        return await subscribeStock(stock);
      } catch (e) {
        console.log(e);
      }
    }
  };
  const getRankList = async () => {
    if (isCustomRank.value) {
      stockList.value = await getCustomRank();
    } else if (isMarketValRank.value) {
      stockList.value = await getMarketValRank();
    } else if (isHotDividendsRanking.value) {
      stockList.value = await getHotDividendsRanking();
    } else {
      stockList.value = await getMarketRank();
    }
    initStockData();
    initChartData();
  };
  const getWchString = stockId => {
    const UNIT_NUM = 10000;
    const UNIT_STR = '萬';
    if (!stockWchNum || !stockWchNum[stockId]) {
      return '0';
    } else if (stockWchNum[stockId] < UNIT_NUM) {
      return stockWchNum[stockId] + '';
    } else {
      // 保留小数点后一位，后一位是 0 则不保留
      return (stockWchNum[stockId] / UNIT_NUM).toFixed(1).replace(/\.0$/, '') + UNIT_STR;
    }
  };
  const getRankCls = index => {
    if (index <= 2) {
      return `rank rank${index + 1}`;
    } else {
      return 'rank';
    }
  };
  const getRatioCls = stock => {
    const upDownColor = props.upDownColor || 0;
    const priceChange = Number(stock.priceChange);
    let direct = '';
    if (priceChange < 0) {
      direct = 'down';
    } else if (priceChange === 0) {
      direct = 'flat';
    }
    return `ratio color-${upDownColor} ${direct}`;
  };
  const getRatioClsByChart = stock => {
    const upDownColor = props.upDownColor || 0;
    if (!chartDatas[stock.stockId]) {
      return `ratio color-${upDownColor}`;
    }
    const priceChange = Number(chartDatas[stock.stockId].priceChange);
    let direct = '';
    if (priceChange < 0) {
      direct = 'down';
    } else if (priceChange === 0) {
      direct = 'flat';
    }
    return `ratio color-${upDownColor} ${direct}`;
  };
  onBeforeMount(() => {
    getRankList();
  });
  return {
    IncreaseTypeMap,
    isPC,
    stockList,
    chartDatas,
    stockStatus,
    tagMap,
    isSupported,
    goScheme,
    subscribeHandler,
    getWchString,
    getRankCls,
    getRatioCls,
    getRatioClsByChart
  };
};
__sfc_main.components = Object.assign({
  SparkChart
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="[
            'self-selected-quote-rank',
            {
                pc: isPC
            }
        ]"
    >
        <div class="header">
            <div class="col-name">{{ col_name }}</div>
            <div class="col-trend">{{ col_trend }}</div>
            <div class="col-increase">{{ IncreaseTypeMap[increaseType] }}</div>
            <div class="col-subscribe">{{ col_subscribe }}</div>
        </div>
        <div class="stocks">
            <div class="stock-item" v-for="(stock, index) in stockList" :key="index">
                <div :class="getRankCls(index)">
                    {{ index > 2 ? index + 1 : '' }}
                </div>
                <div :class="['left', { 'without-tag': !tagMap[stock.shortName] }]" @click="goScheme(stock)">
                    <div class="name-container">
                        <div class="name">{{ stock.name + ' |' }}</div>
                        <div class="short-name">{{ stock.shortName }}</div>
                    </div>
                    <span v-if="tagMap[stock.shortName]" class="tag">{{ tagMap[stock.shortName] }}</span>
                </div>
                <div class="right">
                    <div class="chart-container" @click="goScheme(stock)">
                        <SparkChart
                            v-if="chartDatas && chartDatas[stock.stockId]"
                            :dataSource="chartDatas && chartDatas[stock.stockId]"
                            :upDownColor="upDownColor"
                            :marketId="market_id"
                        />
                    </div>
                    <!-- 接口支持的涨幅类型渲染 stock 中的注入数据即可 -->
                    <span v-if="isSupported" :class="getRatioCls(stock)">
                        {{ stock.priceChange > 0 ? '+' + stock.ratioPriceChange : stock.ratioPriceChange }}
                    </span>
                    <!-- 接口不支持的涨幅类型需要从K线数据中获取 -->
                    <span v-else :class="getRatioClsByChart(stock)">
                        {{ chartDatas[stock.stockId] ? chartDatas[stock.stockId].ratioPriceChange : '0.00%' }}
                    </span>
                    <div class="subscribe">
                        <button
                            :class="['button', stockStatus && stockStatus[stock.stockId] ? 'selected' : 'unselected']"
                            @click="subscribeHandler(stock)"
                        />
                        <div v-if="show_subscribe_number" class="number">{{ getWchString(stock.stockId) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import './index.less';
</style>
